<template>
  <v-main>
    <div class="d-flex justify-end pt-2 pr-4">
      <SwitchLanguage />
    </div>
    <router-view></router-view>
  </v-main>
</template>

<script src="./js/offlineLayout.js"></script>